/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { DarkModeContext } from '../contexts/DarkModeProvider';
import { useContext } from 'react';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function LevelSelect({
  handleKeyStage1,
  handleKeyStage2,
  handleFinLevel,
}) {
  const theme = useContext(DarkModeContext);
  const { syntax, bg } = theme.mode;

  return (
    <Menu as="div" className="relative inline-block text-left z-10 ml-2">
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
              title="Filter by Level"
              aria-label="Filter by Level"
              style={{ background: bg, color: syntax }}
            >
              Level
              <ChevronDownIcon
                className="-mr-1 ml-2 h-5 w-5"
                aria-hidden="true"
              />
            </Menu.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none max-w-max"
            >
              <div className="py-1">
                <Menu.Item onClick={handleKeyStage1}>
                  {({ active }) => (
                    <button
                      className={classNames(
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'block px-8 py-2 text-sm'
                      )}
                    >
                      Key Stage 1
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item onClick={handleKeyStage2}>
                  {({ active }) => (
                    <button
                      className={classNames(
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'block px-8 py-2 text-sm'
                      )}
                    >
                      Key Stage 2
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item onClick={handleFinLevel}>
                  {({ active }) => (
                    <button
                      className={classNames(
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                        'block px-4 py-2 text-sm'
                      )}
                    >
                      Financial Literacy
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}
